<template>
    <app-dialog
        :open="open"
        :title="title"
        :title-id="headlineId"
        size="sm"
        :busy="busy"
        @close="$emit('close')"
    >
        <p class="text-sm leading-6 text-gray-500">{{ text }}</p>

        <template #footer>
            <app-dialog-action
                :label="resolvedConfirmLabel"
                :variant="resolvedConfirmVariant"
                :disabled="busy"
                :loading="busy"
                :loading-label="loadingLabel"
                @click="$emit('confirm')"
            />
        </template>
    </app-dialog>
</template>

<script>
import AppDialog from '@/components/modals/app-dialog.vue';
import AppDialogAction from '@/components/modals/app-dialog-action.vue';

export default {
    name: 'confirm-dialog',
    components: {AppDialog, AppDialogAction},
    props: {
        open: {type: Boolean, default: false},
        title: {type: String, default: ''},
        text: {type: String, default: ''},
        confirmLabel: {type: String, default: ''},
        confirmVariant: {
            type: String,
            default: '',
            validator: (value) => ['', 'primary', 'danger', 'neutral'].includes(value),
        },
        busy: {type: Boolean, default: false},
        loadingLabel: {type: String, default: 'Wird ausgeführt …'},
        headlineId: {type: String, default: 'confirm-dialog-headline'},

        // Compatibility props for existing consumers. New dialogs should use
        // confirmVariant and the close control provided by AppDialog.
        confirmButtonClass: {type: String, default: 'btn btn-red'},
        closeLabel: {type: String, default: ''},
        hideCloseButton: {type: Boolean, default: false},
        showHeaderCloseButton: {type: Boolean, default: false},
        sectioned: {type: Boolean, default: false},
    },
    emits: ['confirm', 'close'],
    computed: {
        resolvedConfirmLabel() {
            return this.confirmLabel || this.$t('Delete').toString();
        },
        resolvedConfirmVariant() {
            if (this.confirmVariant) return this.confirmVariant;

            return /(?:red|danger)/i.test(this.confirmButtonClass) ? 'danger' : 'primary';
        },
    },
};
</script>
